const translations = {
    addFlightError: 'Failed to add flights to flight group. Please try again later.',
    addProductUsageReportToFlightGroupError:
        'Failed to add product usage report to flight group. Please try again later.',
    addWorkOrderToFlightGroupError:
        'Failed to add work order to flight group. Please try again later.',
    createFlightGroupError: 'Failed to create flight group. Please try again later.',
    deleteFlightGroupError: 'Failed to delete flight group. Please try again later.',
    fetchFlightGroupError: 'Failed to fetch flight group. Please try again later.',
    fetchFlightGroupsError: 'Failed to fetch flight groups. Please try again later.',
    fetchFlightsError: 'Failed to fetch flights Please try again later.',
    fetchMapError: 'Failed to fetch maps for flight group. Please try again later.',
    removeFlightFromFlightGroupError:
        'Failed to remove flights from flight group. Please try again later.',
    removeProductUsageReportFromFlightGroupError:
        'Failed to remove product usage report from flight group. Please try again later.',
    removeWorkOrderFromFlightGroupError:
        'Failed to remove work order from flight group. Please try again later.',
    requestMapError: 'Failed to request map for flight group. Please try again later.',
    updateFlightGroupError: 'Failed to update flight group. Please try again later.'
};

export default translations;
